import { TranslatePipe } from '../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import UserConsentRestServices from '../../../services/user-consent-rest.service';
import UserService from '../../../services/user.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import RoutingService from '../../../services/routing.service';

@Component({
	standalone: true,
	selector: 'x-road-local-consents',
	templateUrl: './x-road-local-consents.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export default class XRoadLocalConsentComponent implements OnInit {
	private userConsentRestServices: UserConsentRestServices = inject(UserConsentRestServices);
	private userService: UserService = inject(UserService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.loading = false;
		this.routingService.validateAccess('consents').then(() => {
			var requestParams: any = {
				pageSize: 10,
				start: 0
			};
			this.userConsentRestServices.getGeneralConsents(requestParams).then((consents) => {
				this.vm.consents = consents;
				this.onResolve();
			});
		});
	}
	
	onResolve() {
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.vm.updateConsents = this.updateConsents;
	}
	
	updateConsents(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.loading) {
			return;
		}
		this.vm.loading = true;
		
		this.userConsentRestServices.updateXRoadConsents(this.vm.consents, (res) => {
			this.userService.clearEhifData();
			var returnPath: any = this.vm.params['comingFrom'];
			var newObject: any = (this.vm.params ? Object.assign({}, this.vm.params) : {});
			delete newObject['comingFrom'];
			if (!returnPath) {
				returnPath = '';
			}
			this.angularRoutingHelperService.setPath(returnPath, false, false, newObject);
		});
	}
	
}